import {
  type InputStrategy,
  type BaseInputConfig,
  type QuestionInputConfig,
  type QuestionDto,
} from '@forthbridge/forms';

export class SingleSelectButtonGroupStrategy implements InputStrategy {
  build(base: BaseInputConfig, question: QuestionDto): QuestionInputConfig {
    return {
      ...base,
      // TODO: Find a fix for this
      // @ts-ignore
      shouldSetInitialValue: question.controlConfig?.shouldSetInitialValue,
      options: question.options ?? [],
    };
  }
}
